import { ROLES } from '../constants';
import { UsersListItem } from '../types';

export type MentorSelectOption = {
  value: string;
  label: string;
  firstName: string;
  lastName: string;
  email: string;
};

/** Keep only mentors that are NOT irrelevant.
 *  Irrelevant = has a purchase AND sole role is "mentor"
 *  (owners/sysadmins testing purchases become mentors but shouldn't appear). */
export function isRelevantMentor(mentor: UsersListItem): boolean {
  const isSolelyMentor =
    mentor.roles.length === 1 && mentor.roles[0] === ROLES.mentor;
  return !(mentor.hasPurchase && isSolelyMentor);
}

export function buildMentorSelectOptions(
  mentors: UsersListItem[],
  currentMentorId?: string,
): MentorSelectOption[] {
  return mentors
    .filter(
      (mentor) => isRelevantMentor(mentor) || mentor._id === currentMentorId,
    )
    .map((mentor) => ({
      value: mentor._id,
      label: `${mentor.firstName} ${mentor.lastName} (${mentor.email})`,
      firstName: mentor.firstName,
      lastName: mentor.lastName,
      email: mentor.email,
    }));
}

export function formatMentorOptionLabel(
  option: MentorSelectOption,
  { multiline = false }: { multiline?: boolean } = {},
) {
  if (multiline) {
    return (
      <div className="flex flex-col leading-tight">
        <span>
          {option.firstName} {option.lastName}
        </span>
        <span className="text-slate-400 text-xs">{option.email}</span>
      </div>
    );
  }

  return (
    <span className="flex items-center">
      <span>
        {option.firstName} {option.lastName}
      </span>
      <span className="text-slate-400 text-xs ml-1">({option.email})</span>
    </span>
  );
}

export function findMentorOption(
  options: MentorSelectOption[],
  mentorId?: string,
): MentorSelectOption | undefined {
  return options.find((option) => option.value === mentorId);
}
